import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Row } from 'react-bootstrap';
import Button from '../../../components/Button';
import Checkbox from '../../../components/Checkbox/Checkbox';
import CheckboxGroup from '../../../components/Checkbox/CheckboxGroup';
import GenericCards from '../../../components/GenericCards';
import {
  addOrRemoveYearsToGivenDate,
  DateFormats,
  formatDate,
} from '../../../utils/utils';

export type StepProps = {
  data: any;
  dataSavingsContribution: any;
  dataAutoIncrease: any;
  dataInvestment: any;
  collectStepData: (data: any) => void;
  editPreviousStep: (step: number) => void;
};

const SavingsReviewAndConfirmationStep = ({
  data,
  dataSavingsContribution,
  dataAutoIncrease,
  dataInvestment,
  collectStepData,
  editPreviousStep,
}: StepProps) => {
  const handleConfirmationChange = (event: any, values: string[]) => {
    collectStepData({
      ...data,
      confirmation: values[1],
    });
  };

  return (
    <section>
      <Row className="m-0">
        <Col className="p-0">
          <h5 className="mt-12 text-sm-20-lg-24">Review & Confirmation</h5>
          <div className="text-sub1 fw-light text-ligther-grey mt-7 mt-lg-0">
            <span>Review to ensure you've entered everything correctly</span>
          </div>
        </Col>
      </Row>
      <Row className="m-0 pt-12">
        <Col className="p-0 col-12">
          <GenericCards variant="white" className="py-11 px-10">
            <Row className="m-0">
              <Col className="p-0 fs-6 fw-light ps-0">Contribution</Col>
              <Col className="p-0 text-end pe-0">
                <Button
                  variant="primary"
                  size="sm"
                  leftIcon={light('pen-to-square')}
                  onClick={() => {
                    editPreviousStep(0);
                  }}
                >
                  Edit
                </Button>
              </Col>
            </Row>
            <Row className="m-0 pt-12">
              <Col className="p-0 pe-lg-11">
                <Row className="m-0">
                  <Col className="p-0 text-fs-6 pb-3">
                    Contribution Elections
                  </Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light pt-3 lh-xs border-top">
                  <Col className="p-0 text-ligther-grey ">Before-Tax</Col>
                  <Col className="p-0 text-end pe-0">
                    {dataSavingsContribution.beforeTax || 0}%
                  </Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light lh-xs pt-4">
                  <Col className="p-0 text-ligther-grey">Roth 401(k)</Col>
                  <Col className="p-0 text-end">
                    {dataSavingsContribution.roth401 || 0}%
                  </Col>
                </Row>
                <Row className="m-0 border-top text-fs-6 fw-light lh-xs pt-4 mt-4">
                  <Col className="p-0 text-primary">Total</Col>
                  <Col className="p-0 text-primary text-end">
                    {dataSavingsContribution.beforeTax +
                      dataSavingsContribution.roth401 || 0}
                    %
                  </Col>
                </Row>
              </Col>
              <Col className="p-0 col-12 pt-13 pt-lg-0 col-lg-6 ps-lg-11">
                <Row className="m-0">
                  <Col className="p-0 text-fs-6  pb-3">Breakdown</Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light pt-3 lh-xs border-top">
                  <Col className="p-0 text-ligther-grey col-7">
                    Per Paycheck Contribution
                  </Col>
                  <Col className="p-0 text-end">$250</Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light lh-xs pt-4">
                  <Col className="p-0 text-ligther-grey col-7">
                    Potential Company Match
                  </Col>
                  <Col className="p-0 text-end">$150</Col>
                </Row>
                <Row className="m-0 border-top text-fs-6 fw-light lh-xs pt-4 mt-4">
                  <Col className="p-0 text-primary col-7">
                    Estimated Growth by Age 65
                  </Col>
                  <Col className="p-0 text-primary text-end">$150,000</Col>
                </Row>
              </Col>
            </Row>
          </GenericCards>
        </Col>
      </Row>
      <Row className="m-0 pt-12">
        <Col className="p-0 col-12">
          <GenericCards variant="white" className="py-11 px-10">
            <Row className="m-0">
              <Col className="p-0 fs-6 fw-light ps-0">Auto-Increase</Col>
              <Col className="p-0 text-end pe-0">
                <Button
                  variant="primary"
                  size="sm"
                  leftIcon={light('pen-to-square')}
                  onClick={() => {
                    editPreviousStep(1);
                  }}
                >
                  Edit
                </Button>
              </Col>
            </Row>
            <Row className="m-0 pt-12">
              <Col className="p-0 pe-lg-11">
                <Row className="m-0">
                  <Col className="p-0 text-fs-6 pb-3">Status</Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light pt-3 lh-xs border-top">
                  <Col className="p-0 text-ligther-grey ">Enrolled</Col>
                  <Col className="p-0 text-end pe-0">Yes</Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light lh-xs pt-4">
                  <Col className="p-0 text-ligther-grey">
                    Initial Increase Date
                  </Col>
                  <Col className="p-0 text-end">
                    {formatDate(
                      new Date(
                        addOrRemoveYearsToGivenDate(
                          new Date(),
                          1
                        ).getFullYear(),
                        0,
                        1
                      ),
                      DateFormats.MONTH_YEAR
                    )}
                  </Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light lh-xs pt-4">
                  <Col className="p-0 text-ligther-grey">
                    Increase Frequency
                  </Col>
                  <Col className="p-0 text-end">Annually</Col>
                </Row>
              </Col>
              <Col className="p-0 col-12 pt-13 pt-lg-0 col-lg-6 ps-lg-11">
                <Row className="m-0">
                  <Col className="p-0 text-fs-6  pb-3">
                    Contribution Elections
                  </Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light pt-3 lh-xs border-top">
                  <Col className="p-0 text-ligther-grey">Before-Tax</Col>
                  <Col className="p-0 text-start col-5 col-lg-9">
                    Increase by{' '}
                    <span className="fw-bolder text-primary">2%</span> until you
                    reach <span className="fw-bolder text-primary">10%</span> on{' '}
                    {formatDate(
                      new Date(
                        addOrRemoveYearsToGivenDate(
                          new Date(),
                          3
                        ).getFullYear(),
                        0,
                        1
                      ),
                      DateFormats.MONTH_YEAR
                    )}
                  </Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light lh-xs pt-4">
                  <Col className="p-0 text-ligther-grey">Roth 401(k)</Col>
                  <Col className="p-0 text-start col-5 col-lg-9">
                    Increase by{' '}
                    <span className="fw-bolder text-primary">1%</span> until you
                    reach <span className="fw-bolder text-primary">10%</span> on{' '}
                    {formatDate(
                      new Date(
                        addOrRemoveYearsToGivenDate(
                          new Date(),
                          7
                        ).getFullYear(),
                        0,
                        1
                      ),
                      DateFormats.MONTH_YEAR
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </GenericCards>
        </Col>
      </Row>
      <Row className="m-0 pt-12">
        <Col className="p-0 col-12">
          <GenericCards variant="white" className="py-11 px-10">
            <Row className="m-0">
              <Col className="p-0 fs-6 fw-light ps-0">Investment</Col>
              <Col className="p-0 text-end pe-0">
                <Button
                  variant="primary"
                  size="sm"
                  leftIcon={light('pen-to-square')}
                  onClick={() => {
                    editPreviousStep(2);
                  }}
                >
                  Edit
                </Button>
              </Col>
            </Row>
            <Col className="m-0 pt-12">
              <Col className="p-0 col-lg-6">
                <Row className="m-0">
                  <Col className="p-0 text-fs-6 pb-3">Target Date Funds</Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light pt-3 lh-xs border-top">
                  <Col className="p-0 text-ligther-grey col-9">
                    Vanguard Target Retire 2060 Tr I
                  </Col>
                  <Col className="p-0 text-end pe-0">50%</Col>
                </Row>
              </Col>
              <Col className="p-0 col-12 pt-13 pt-lg-11 col-lg-6">
                <Row className="m-0">
                  <Col className="p-0 text-fs-6  pb-3">
                    Domestic Equity/Stock
                  </Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light pt-3 lh-xs border-top">
                  <Col className="p-0 text-ligther-grey col-10">
                    Vanguard Dividend Growth Inv
                  </Col>
                  <Col className="p-0 text-end col-2">10%</Col>
                </Row>
                <Row className="m-0 text-fs-6 fw-light lh-xs pt-4">
                  <Col className="p-0 text-ligther-grey col-10">
                    BlackRock Advantage Small Cap Core Fund
                  </Col>
                  <Col className="p-0 text-end col-2">40%</Col>
                </Row>
              </Col>
            </Col>
          </GenericCards>
        </Col>
      </Row>
      <Row className="pt-11">
        <Col>
          <CheckboxGroup
            name="termsAndConditions"
            value={[data.confirmation]}
            onChange={handleConfirmationChange}
          >
            <Checkbox
              id={'confirm-step'}
              value={'agree'}
              variant="sm"
              label={
                'By checking the box, I indicate my acceptance of these terms.'
              }
              className="mt-6"
            />
          </CheckboxGroup>
        </Col>
      </Row>
      <Row>
        <Col className="pt-11 px-12 fw-light lh-xs text-fs-6 col">
          <div>
            <span>
              I acknowledge that I am solely responsible for any and all
              investment choices or other directions that I give for my account
              through this website.
            </span>
          </div>
          <div className="mt-8">
            <span>
              L@W Connect attempts to make this website available to me 24 hours
              each day. Occasionally this website may not be available, or for
              other reasons it may not be possible to execute my investment
              choices or other directions. This website and its representatives
              are not responsible for transactions that cannot be executed on
              such occasions.
            </span>
          </div>
          <div className="mt-8">
            <span>
              My employer has authorized L@W Connect to provide information to,
              and act on instructions received from, anyone using this internet
              service and representing himself or herself to be me. L@W Connect
              will employ reasonable procedures to verify the identity of anyone
              representing himself or herself to be me. Requiring a Social
              Security number and a passcode to confirm identity will be
              considered reasonable.
            </span>
          </div>
          <div className="mt-8">
            <span>
              If L@W Connect follows reasonable procedures, it will not be
              liable for any consequence of providing information to or acting
              on instructions from someone other than me.
            </span>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default SavingsReviewAndConfirmationStep;
